import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock, Mail } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-[#0B2A4A] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-[#2F80ED] to-white rounded-lg flex items-center justify-center">
                <span className="text-[#0B2A4A] font-bold text-xl">AT</span>
              </div>
              <div>
                <h3 className="font-bold text-lg">{companyInfo.name}</h3>
                <p className="text-sm text-gray-300">{companyInfo.tagline}</p>
              </div>
            </div>
            <p className="text-sm text-gray-300 leading-relaxed mb-4">
              Votre artisan plombier de confiance à Lyon. Plus de 10 ans d'expérience au service de votre confort.
            </p>
            {/* Badge Google - Nouveau */}
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-3 py-2 rounded-lg border border-white/20">
              <span className="text-yellow-400 text-lg">⭐</span>
              <span className="text-sm font-semibold text-white">
                Note Google : {companyInfo.rating}/5 — {companyInfo.reviewCount} avis
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-300 hover:text-[#2F80ED] transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-300 hover:text-[#2F80ED] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/zones-tarifs" className="text-sm text-gray-300 hover:text-[#2F80ED] transition-colors">
                  Zones & Tarifs
                </Link>
              </li>
              <li>
                <Link to="/avis" className="text-sm text-gray-300 hover:text-[#2F80ED] transition-colors">
                  Avis clients
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-sm text-gray-300 hover:text-[#2F80ED] transition-colors">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-300 hover:text-[#2F80ED] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-1 text-[#2F80ED]" />
                <div>
                  <a href={`tel:${companyInfo.phoneFormatted}`} className="text-sm text-gray-300 hover:text-[#2F80ED] transition-colors">
                    {companyInfo.phone}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-1 text-[#2F80ED]" />
                <div>
                  <a href={`mailto:${companyInfo.email}`} className="text-sm text-gray-300 hover:text-[#2F80ED] transition-colors">
                    {companyInfo.email}
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 text-[#2F80ED]" />
                <div>
                  <p className="text-sm text-gray-300">{companyInfo.address}</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-bold text-lg mb-4">Horaires</h4>
            <ul className="space-y-2">
              <li className="flex items-start gap-2">
                <Clock className="w-4 h-4 mt-1 text-[#2F80ED]" />
                <div>
                  <p className="text-sm text-gray-300">{companyInfo.hours.weekdays}</p>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="w-4 h-4 mt-1 text-[#2F80ED]" />
                <div>
                  <p className="text-sm text-gray-300">{companyInfo.hours.saturday}</p>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Clock className="w-4 h-4 mt-1 text-[#2F80ED]" />
                <div>
                  <p className="text-sm text-gray-300">{companyInfo.hours.sunday}</p>
                </div>
              </li>
              <li className="pt-2 border-t border-gray-700">
                <p className="text-sm text-[#2F80ED] font-semibold">{companyInfo.hours.emergency}</p>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} {companyInfo.name}. Tous droits réservés.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="text-sm text-gray-400 hover:text-[#2F80ED] transition-colors">
              Mentions légales
            </Link>
            <Link to="#" className="text-sm text-gray-400 hover:text-[#2F80ED] transition-colors">
              Politique de confidentialité
            </Link>
            <Link to="#" className="text-sm text-gray-400 hover:text-[#2F80ED] transition-colors">
              CGV
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
